/** Injectable wall clock (epoch milliseconds). The server core never calls Date.now() directly. */
export interface Clock {
  now(): number;
}

export const systemClock: Clock = { now: () => Date.now() };

/** Manually driven clock for tests and deterministic simulations. */
export class ManualClock implements Clock {
  private t: number;
  constructor(start = Date.UTC(2026, 0, 1)) {
    this.t = start;
  }
  now(): number {
    return this.t;
  }
  set(t: number): void {
    this.t = t;
  }
  advance(ms: number): number {
    this.t += ms;
    return this.t;
  }
}
